import axios from "axios"
import { URL_BASE } from '../../../config/config'

const RESOURCE = 'properties'

export default {
    state: {
        items: {
            data: []
        },

        store: false
    },
    
    mutations: {
        LOAD_PROPERTIES (state, data) {
            state.items = data
        },

        STORE_PROPERTIES (state, status) {
            state.store = status
        }
    },

    actions: {
        async loadProperties({ commit }, params) {
            try {
                commit('PRELOADER', true); // Inicia o estado de carregamento
                const response = await axios.get(`${URL_BASE}${RESOURCE}`, { params }); // Faz a requisição
                commit('LOAD_PROPERTIES', response.data); // Atualiza o estado Vuex com os dados da API
            } catch (error) {
                if (error.response && error.response.status === 401) {
                    window.location.href = "login"; // Redireciona para login se não autorizado
                } else {
                    console.error('Erro ao carregar propriedades:', error);
                }
            } finally {
                commit('PRELOADER', false); // Finaliza o estado de carregamento
            }
        },


        /* 
        loadProperties(context, params) {
            context.commit('PRELOADER', true)
            axios.get(`${URL_BASE}${RESOURCE}`, {params})
                .then( response =>
                        {
                            context.commit('LOAD_PROPERTIES', response.data)
                        }
                )
                //.catch( errors => console.log(errors))
                .catch((error) => {
                    if(error.response && error.response.status === 401) {
                        window.location.href = "login";
                    }

                })
                .finally(() => context.commit('PRELOADER', false))
        },
        */

        loadPromisseProperties(context, params) {
            context.commit('PRELOADER', true)
            return new Promise((resolve, reject) => {
                axios.get(`${URL_BASE}${RESOURCE}`, {params})
                    .then(response => resolve(response.data))
                    .catch(function(error) {
                        if (error.response && error.response.status === 401) {
                          window.location.href = "login";
                        }
                        reject(error)
                    })
                    .finally(() => context.commit('PRELOADER', false))
            })
        },
        

        loadPropertiesExcel(context, params) {
            context.commit('PRELOADER', true)
            return new Promise((resolve, reject) => {
                axios.get(`${URL_BASE}${RESOURCE}`, {params})
                    .then(response => resolve(response.data))
                    .catch(function(error) {
                        if (error.response && error.response.status === 401) {
                          window.location.href = "login";
                        }
                        reject(error)
                    })
                    .finally(() => context.commit('PRELOADER', false))
            })
        },

        storeProperty(context, params) {
            context.commit('PRELOADER', true)
            return new Promise((resolve) => {
                axios.post(`${URL_BASE}${RESOURCE}`, params)
                    .then(
                        response => resolve(response.data
                    ))
                    .catch(function(error) {
                        if (error.response && error.response.status === 401) {
                          window.location.href = "login";
                        }
                    })
                    .finally(() => context.commit('PRELOADER', false))
            })
        },
        
        updateProperty(context, params){
            context.commit('PRELOADER', true)
            return new Promise((resolve, reject) => {
                axios.put(`${URL_BASE}${RESOURCE}/${params.id}`, params)
                    .then(response => resolve(response.data))
                    .catch(function(error) {
                        if (error.response && error.response.status === 401) {
                          window.location.href = "login";
                        }
                        reject(error)
                    })
                    .finally(() => context.commit('PRELOADER', false))
            })
        },

        updatePropertyStatus(context, params){
            context.commit('PRELOADER', true)
            return new Promise((resolve, reject) => {
                axios.put(`${URL_BASE}properties_status/${params.id}`, params)
                    .then(response => resolve(response.data))
                    .catch(function(error) {
                        if (error.response && error.response.status === 401) {
                          window.location.href = "login";
                        }
                        reject(error)
                    })
                    .finally(() => context.commit('PRELOADER', false))
            })
        },

        loadProperty(context, id) {
            context.commit('PRELOADER', true)
            return new Promise((resolve, reject) => {
                axios.get(`${URL_BASE}${RESOURCE}/${id}`)
                    .then(response => resolve(response.data))
                    .catch(function(error) {
                        if (error.response && error.response.status === 401) {
                          window.location.href = "login";
                        }
                        reject(error)
                    })
                    .finally(() => context.commit('PRELOADER', false))
            })
        },

        destroyProperty(context, id){
            context.commit('PRELOADER', true)
            return new Promise((resolve, reject) => {
                axios.delete(`${URL_BASE}${RESOURCE}/${id}`)
                    .then(response => resolve(response.data))
                    .catch(error => reject(error))
                    .finally(() => context.commit('PRELOADER', false))    
            })
        },

        // add methods
        newProperty(context, params) {
            context.commit('PRELOADER', true)
            return new Promise((resolve, reject) => {
                axios.get(`${URL_BASE}propertynew`, {params})
                    .then(response => resolve(response.data))
                    .catch(function(error) {
                        if (error.response && error.response.status === 401) {
                          window.location.href = "login";
                        }
                        reject(error)
                    })
                    .finally(() => context.commit('PRELOADER', false))
            })
        },

        copyProperty(context, params) {
            context.commit('PRELOADER', true)
            return new Promise((resolve, reject) => {
                axios.get(`${URL_BASE}copyproperty`, {params})
                    .then(response => resolve(response.data))
                    .catch(function(error) {
                        if (error.response && error.response.status === 401) {
                          window.location.href = "login";
                        }
                        reject(error)
                    })
                    .finally(() => context.commit('PRELOADER', false))
            })
        },

        countProperties(context) {
            context.commit('PRELOADER', true)
            return new Promise((resolve, reject) => {
                axios.get(`${URL_BASE}${RESOURCE}`)
                    .then(response => resolve(response.data))
                    .catch(function(error) {
                        if (error.response && error.response.status === 401) {
                          window.location.href = "login";
                        }
                        reject(error)
                    })
                    .finally(() => context.commit('PRELOADER', false))
            })
        },

        properties_total(context) {
            context.commit('PRELOADER', true)
            return new Promise((resolve, reject) => {
                axios.get(`${URL_BASE}properties_total`)
                    .then(response => resolve(response.data))
                    .catch(function(error) {
                        if (error.response && error.response.status === 401) {
                          window.location.href = "login";
                        }
                        reject(error)
                    })
                    .finally(() => context.commit('PRELOADER', false))
            })
        },

        propertyEmail(context, params) {
            context.commit('PRELOADER', true)
            return new Promise((resolve, reject) => {
                axios.get(`${URL_BASE}propertyemails`, {params})
                    .then(response => resolve(response.data))
                    .catch(function(error) {
                        if (error.response && error.response.status === 401) {
                          window.location.href = "login";
                        }
                        reject(error)
                    })
                    .finally(() => context.commit('PRELOADER', false))
            })
        },

        loadShowPortalProperty(context, id){
            context.commit('PRELOADER', true)
            return new Promise((resolve, reject) => {
                axios.get(`${URL_BASE}show_portal/${id}`)
                    .then(response => resolve(response.data))
                    .catch(function(error) {
                        if (error.response && error.response.status === 401) {
                          window.location.href = "login";
                        }
                        reject(error)
                    })
                    .finally(() => context.commit('PRELOADER', false))
            })
        },

        printProperty(context, params) {
            context.commit('PRELOADER', true)
            axios.get(`${URL_BASE}print_property`,{
                    responseType: "blob",
                    params: params 
                })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', params.file_name);
                    document.body.appendChild(link);
                    link.click();
                })
                .finally(() => context.commit('PRELOADER', false))
        },

        printFullProperty(context, params) {
            context.commit('PRELOADER', true)
            axios.get(`${URL_BASE}print_full_property`,{
                    responseType: "blob",
                    params: params 
                })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', params.file_name);
                    document.body.appendChild(link);
                    link.click();
                    return 'download concluido';
                })
                .finally(() => context.commit('PRELOADER', false))
        },

        property_distinct(context, params){
            context.commit('PRELOADER', true)
            return new Promise((resolve, reject) => {
                axios.get(`${URL_BASE}property_distinct`, { params })
                    .then(response => resolve(response.data))
                    .catch(function(error) {
                        if (error.response && error.response.status === 401) {
                          window.location.href = "login";
                        }
                        reject(error)
                    })
                    .finally(() => context.commit('PRELOADER', false))
            })
        },

        property_viewing_form(context, params) {
            context.commit('PRELOADER', true)
            axios.get(`${URL_BASE}property_viewing_form`,{
                    responseType: "blob",
                    params: params 
                })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', params.file_name);
                    document.body.appendChild(link);
                    link.click();
                    return 'download concluido';
                })
                .finally(() => context.commit('PRELOADER', false))
        },

        property_export(context, params) {      
            return new Promise((resolve, reject) => {  
                axios.get(`${URL_BASE}property_export`, {
                    responseType: "blob",
                    params: params 
                  })
                    .then(response => {
                        const url = URL.createObjectURL(
                            new Blob([response.data], {
                                type: "application/vnd.ms-excel"
                            })
                        );
                        const link = document.createElement("a");
                        link.href = url;
                        link.setAttribute("download", "imoveis.xls");
                        document.body.appendChild(link);
                        link.click();
                        resolve('Download concluído com sucesso!');
                    })
                    .catch(function(error) {
                        if (error.response && error.response.status === 401) {
                          window.location.href = "login";
                        }
                        reject(error)
                    })
                    .finally(() => context.commit('PRELOADER', false))    
            })            
        },

        async property_export_code_comma(context, params) {
            context.commit('PRELOADER', true)
            try {
                const response = await axios.get(`${URL_BASE}property_export_code_comma`, { params })
                return response.data
            } catch (error) {
                if (error.response && error.response.status === 401) {
                    window.location.href = "login"
                }
                throw error // equivalente a reject(error)
            } finally {
                context.commit('PRELOADER', false)
            }
        }

    },

    getters: {

    }

}